import React from "react";
import { useTranslation } from "react-i18next";
import { Buttons, Icons } from "components";
import SeatPriceSummary from "../SeatPriceSummary";

// S5 ตรวจสอบข้อมูลอีกครั้งก่อนส่ง (ส่ง = สร้างการจองสถานะรอตรวจสลิป)
// แถบ "กลับไปแก้ไขข้อมูล" แบบเดียวกับหน้าตรวจสอบของ Music Hall พากลับไปหน้าข้อมูลผู้จอง
const ReviewStep = ({ draft, slipFile, onBack, onEdit, onSubmit }) => {
  const { t } = useTranslation(["seat"]);
  const booker = draft.booker || {};
  const tax = draft.tax_invoice || {};
  const school =
    draft.school_code && draft.school_code !== "GEN"
      ? `${draft.school_code} · ${draft.school_name || ""}`
      : t("Not specified", { ns: "seat" });
  return (
    <div className="step_body">
      <div className="back_edit_bar" onClick={onEdit}>
        <Icons.ArrowLeft2 color="#4B1E78" />
        {t("Back to edit information", { ns: "seat" })}
      </div>
      <div className="review_title">{t("Review your booking", { ns: "seat" })}</div>
      <SeatPriceSummary draft={draft} />
      <div className="review_card">
        <div className="rv_title">{t("Booker (member)", { ns: "seat" })}</div>
        <div>
          {[`${booker.first_name || ""} ${booker.last_name || ""}`.trim(), booker.phone, booker.email]
            .filter(Boolean)
            .join(" · ")}
        </div>
        <div>
          {t("School", { ns: "seat" })} {school}
        </div>
        <div>
          {t("Tax invoice", { ns: "seat" })}:{" "}
          {tax.is_required
            ? [tax.name, tax.branch, tax.tax_id].filter(Boolean).join(" · ")
            : t("Not required", { ns: "seat" })}
        </div>
      </div>
      <div className="rv_slip">
        {t("Attached slip", { ns: "seat" })}: {slipFile ? slipFile.name : t("Slip attached", { ns: "seat" })}
        <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
          <rect width="20" height="20" rx="4" fill="#34C759" />
          <path d="M5.5 10.2l3 3 6-6.4" stroke="#FFF" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <div className="rv_btns">
        <div className="rv_back">
          <Buttons.BgStandard theme_white_purple label={t("Back", { ns: "seat" })} onClick={onBack} />
        </div>
        <div className="rv_submit">
          <Buttons.BgStandard height="48px" label={t("Confirm and submit", { ns: "seat" })} onClick={onSubmit} />
        </div>
      </div>
    </div>
  );
};

export default ReviewStep;
